import { UploadOutlined } from "@ant-design/icons";
import { Alert, Button, Col, Row, Upload } from "antd";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import LabelSelect from "../../../../components/select/LabelSelect";
import {
  URL_BASE,
  URL_BASE_ACCESOPROVEEDORES,
} from "../../../../constants/url";
import {
  startGetArchivos,
  startGetAsistencia,
} from "../../../../context/actions/asistenciasActions";
import { useUploadFile } from "../../../../hooks/useUploadFile";
import { post } from "../../../../utils/fetch";
import { opcionesArchivo } from "../../../../constants/cons";
import { useState } from "react";
import { ImagenPlaca } from "./ImagenPlaca";

export const SubirEvidencia = () => {
  const dispatch = useDispatch();
  const [err, setErr] = useState(null);
  const { asistenciaID } = useParams();
  const url = `${URL_BASE_ACCESOPROVEEDORES}/PostDocumento`;
  const { body, setBody, handleClick } = useUploadFile(url, asistenciaID); // 0 = factura

  const props = {
    beforeUpload: (file) => {
      setBody({ ...body, file });
      // console.log(body);
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const handleChangeSelect = (val) => {
    setBody({ ...body, nombre: val });
  };

  const envia = async () => {
    setErr(null);
    if (body.nombre === "placas") {
      const formData = new FormData();
      formData.append("file", body.file);
      formData.append("asistenciaId", asistenciaID);

      const res = await post(`${URL_BASE}/api/Placas`, formData);
      console.log(res);
      if (res.code !== 0) setErr(res.error);
      else dispatch(startGetAsistencia(asistenciaID, true));
    } else {
      handleClick().then(() => dispatch(startGetArchivos(asistenciaID)));
    }
  };

  // console.log(err);
  return (
    <div>
      <div className="subtituloMenos">Subir evidencia</div>
      <Row gutter={10}>
        <Col span={10} style={{ paddingTop: 2 }}>
          <LabelSelect
            opciones={opcionesArchivo}
            label="Nombre"
            value={body.nombre}
            onChange={handleChangeSelect}
          />
          <div style={{ marginTop: 5, fontSize: 12, color: "orange" }}>
            {body.file?.name}
          </div>
        </Col>

        <Col span={8}>
          <Upload {...props} style={{ width: "100%" }}>
            <Button
              style={{ textAlign: "left", marginTop: 20 }}
              icon={<UploadOutlined />}
            >
              Seleccione documento
            </Button>
          </Upload>
        </Col>
        <Col span={2}>
          <Button type="primary" style={{ marginTop: 20 }} onClick={envia}>
            Agregar
          </Button>
        </Col>
      </Row>

      {err && <Alert type="warning" message={err} />}
      <hr />
      <ImagenPlaca />
    </div>
  );
};
